import _kebabCase from "lodash/kebabCase";
import _cloneDeep from "lodash/cloneDeep";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "dialog-footer"
};
import { useCommonDialog } from '@/component-create/utils/hooks';
import { toast } from '@/utils/message';
import { genToPath } from '../../api/code-gen';

import { ref, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'GenToPath',
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var dialogRef = useCommonDialog('dialogRef');
    var dialog = ref({
      saving: false
    });
    var business = ref({
      frontendPath: '',
      backendPath: '',
      moduleName: '',
      businessName: '',
      basePackage: '',
      config: null,
      businessComment: ''
    });
    var config = ref({
      override: false
    });
    var frontend = ref(false);
    var backend = ref(false);
    var frontendSeparator = computed(function () {
      return business.value.frontendPath.indexOf('/') === -1 ? '\\' : '/';
    });
    var backendSeparator = computed(function () {
      return business.value.backendPath.indexOf('/') === -1 ? '\\' : '/';
    });
    var packagePath = computed(function () {
      var separator = backendSeparator.value;
      return "".concat(business.value.basePackage.replace(/\./g, separator)).concat(separator, "\n            ").concat(business.value.moduleName);
    });
    var viewPath = computed(function () {
      var separator = frontendSeparator.value;
      return "".concat(business.value.frontendPath).concat(separator, "src").concat(separator, "views").concat(separator).concat(business.value.moduleName).concat(separator).concat(kebab(business.value.businessName)).concat(separator);
    });
    var apiName = computed(function () {
      return "".concat(kebab(business.value.businessName), ".js");
    });
    var apiPath = computed(function () {
      var separator = frontendSeparator.value;
      return "".concat(business.value.frontendPath).concat(separator, "src").concat(separator, "api").concat(separator, "\n  ").concat(business.value.moduleName).concat(separator);
    });
    var classPath = computed(function () {
      var separator = backendSeparator.value;
      return "".concat(business.value.backendPath).concat(separator, "src").concat(separator, "main").concat(separator, "java").concat(separator).concat(packagePath.value);
    });
    var resourcesPath = computed(function () {
      var separator = backendSeparator.value;
      return "".concat(business.value.backendPath).concat(separator, "src").concat(separator, "main").concat(separator, "resources");
    });
    function show(biz) {
      Object.assign(business.value, biz);
      config.value.override = false;
      backend.value = false;
      frontend.value = false;
      dialogRef.open();
    }
    function handleGenerate() {
      var biz = _cloneDeep(business.value);
      if (!frontend.value) {
        biz.frontendPath = '';
      }
      if (!backend.value) {
        biz.backendPath = '';
      }
      if (!biz.config) {
        biz.config = {};
      }
      Object.assign(biz.config, config.value);
      dialog.value.saving = true;
      genToPath(biz).then(function () {
        toast.success('生成成功');
        dialogRef.close();
      }).finally(function () {
        dialog.value.saving = false;
      });
    }
    function kebab(str) {
      return _kebabCase(str);
    }
    __expose({
      show: show
    });
    return function (_ctx, _cache) {
      var _component_el_checkbox = _resolveComponent("el-checkbox");
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_form = _resolveComponent("el-form");
      var _component_el_button = _resolveComponent("el-button");
      var _component_x_common_dialog = _resolveComponent("x-common-dialog");
      return _openBlock(), _createBlock(_component_x_common_dialog, {
        ref_key: "dialogRef",
        ref: dialogRef,
        title: "生成到指定路径",
        width: "60%",
        closeable: !_unref(dialog).saving
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_checkbox, {
            modelValue: _unref(config).override,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return _unref(config).override = $event;
            })
          }, {
            default: _withCtx(function () {
              return _cache[14] || (_cache[14] = [_createTextVNode("覆盖已存在的文件")]);
            }),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_button, {
            type: "primary",
            style: {
              "margin-left": "10px"
            },
            loading: _unref(dialog).saving,
            disabled: !_unref(frontend) && !_unref(backend),
            onClick: handleGenerate
          }, {
            default: _withCtx(function () {
              return _cache[15] || (_cache[15] = [_createTextVNode("生成 ")]);
            }),
            _: 1
          }, 8, ["loading", "disabled"])])];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            "label-width": "80px"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                label: "前端路径"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    modelValue: _unref(business).frontendPath,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return _unref(business).frontendPath = $event;
                    }),
                    maxlength: "512",
                    disabled: !_unref(frontend)
                  }, {
                    append: _withCtx(function () {
                      return [_createVNode(_component_el_checkbox, {
                        modelValue: _unref(frontend),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                          return _isRef(frontend) ? frontend.value = $event : null;
                        })
                      }, null, 8, ["modelValue"])];
                    }),
                    _: 1
                  }, 8, ["modelValue", "disabled"]), _createTextVNode(" " + _toDisplayString(_unref(business).businessName) + ".vue：" + _toDisplayString(_unref(viewPath)) + _toDisplayString(_unref(business).businessName) + ".vue ", 1), _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)), _createTextVNode(" config.ts：" + _toDisplayString(_unref(viewPath)) + "config.ts ", 1), _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(kebab(_unref(business).businessName)) + ".ts：" + _toDisplayString(_unref(apiPath)) + _toDisplayString(_unref(apiName)), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "后端路径"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    modelValue: _unref(business).backendPath,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                      return _unref(business).backendPath = $event;
                    }),
                    maxlength: "512",
                    disabled: !_unref(backend)
                  }, {
                    append: _withCtx(function () {
                      return [_createVNode(_component_el_checkbox, {
                        modelValue: _unref(backend),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                          return _isRef(backend) ? backend.value = $event : null;
                        })
                      }, null, 8, ["modelValue"])];
                    }),
                    _: 1
                  }, 8, ["modelValue", "disabled"]), _createTextVNode(" " + _toDisplayString(_unref(business).businessName) + ".java：" + _toDisplayString(_unref(classPath)) + _toDisplayString(_unref(backendSeparator)) + "entity" + _toDisplayString(_unref(backendSeparator)) + _toDisplayString(_unref(business).businessName) + ".java ", 1), _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(_unref(business).businessName) + "Controller.java：" + _toDisplayString(_unref(classPath)) + _toDisplayString(_unref(backendSeparator)) + "controller" + _toDisplayString(_unref(backendSeparator)) + _toDisplayString(_unref(business).businessName) + "Controller.java ", 1), _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(_unref(business).businessName) + "Service.java：" + _toDisplayString(_unref(classPath)) + _toDisplayString(_unref(backendSeparator)) + "service" + _toDisplayString(_unref(backendSeparator)) + _toDisplayString(_unref(business).businessName) + "Service.java ", 1), _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(_unref(business).businessName) + "ServiceImpl.java：" + _toDisplayString(_unref(classPath)) + _toDisplayString(_unref(backendSeparator)) + "service" + _toDisplayString(_unref(backendSeparator)) + "impl" + _toDisplayString(_unref(backendSeparator)) + _toDisplayString(_unref(business).businessName) + "ServiceImpl.java ", 1), _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(_unref(business).businessName) + "Mapper.java：" + _toDisplayString(_unref(classPath)) + _toDisplayString(_unref(backendSeparator)) + "mapper" + _toDisplayString(_unref(backendSeparator)) + _toDisplayString(_unref(business).businessName) + "Mapper.java ", 1), _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(_unref(business).businessName) + "Mapper.xml：" + _toDisplayString(_unref(classPath)) + _toDisplayString(_unref(backendSeparator)) + "mapper" + _toDisplayString(_unref(backendSeparator)) + _toDisplayString(_unref(business).businessName) + "Mapper.xml ", 1), _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(_unref(business).businessName) + "ImportHandler.java：" + _toDisplayString(_unref(classPath)) + _toDisplayString(_unref(backendSeparator)) + "handler" + _toDisplayString(_unref(backendSeparator)) + _toDisplayString(_unref(business).businessName) + "ImportHandler.java ", 1), _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(_unref(business).businessComment) + ".xlsx：" + _toDisplayString(_unref(resourcesPath)) + _toDisplayString(_unref(backendSeparator)) + "templates" + _toDisplayString(_unref(backendSeparator)) + _toDisplayString(_unref(business).businessName) + ".xlsx ", 1)];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["closeable"]);
    };
  }
});